// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__1BQgI","container":"Layout_container__1BS0W"};